import React from 'react';

import { WixStyleReactMaskingProviderContextProps } from './WixStyleReactMaskingProvider.types';

export const WixStyleReactMaskingContext = React.createContext(
  {} as WixStyleReactMaskingProviderContextProps,
);
